import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';
const StyledComponent = styled<any, any>('div', 'inputWrapper', 'autocomplete')`
    ${propStyles};
    outline: none;
    cursor: pointer;
`;
StyledComponent.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    padding: 'sm',
    fontSize: 'xs',
    fontFamily: 'body',
    fontWeight: 'normal',
    color: 'body',
    bgColor: 'white',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    hover: {
        borderColor: 'primary',
    },
    selected: {
        color: 'body',
        borderColor: 'primary',
    },
};
export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Autocomplete/StyledComponents/InputWrapper.tsx